import { Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { track } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function AgentProfile({ compact = false }) {
  const site = useSite();
  return (
    <div className={`grid items-center gap-10 ${compact ? "md:grid-cols-[280px_1fr]" : "md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] md:gap-16"}`}
      data-testid="agent-profile">
      <Reveal className="relative mx-auto w-full max-w-sm">
        <div className="absolute -inset-3 rounded-2xl border-2 border-gold/50" aria-hidden="true" />
        <img
          src="/assets/michael.png"
          alt="Michael Janas, independent licensed life insurance agent and founder of 1907 Insurance Group"
          className="relative w-full rounded-2xl object-cover shadow-lg"
          loading="lazy"
          data-testid="agent-photo"
        />
      </Reveal>
      <Reveal delay={0.15}>
        <p className="eyebrow">Meet Your Agent</p>
        <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight">Insurance Guidance From a Real Person</h2>
        <div className="mt-6 space-y-4 text-lg text-mutedink leading-relaxed">
          <p>
            Michael Janas is an independent licensed life insurance agent and the founder of 1907 Insurance Group.
            He helps individuals and families understand their coverage options and choose policies suited to their
            needs, health, and budget.
          </p>
          <p>
            Michael believes buying life insurance should begin with a clear conversation — not pressure. His goal is
            to explain the available options in understandable terms, answer questions honestly, and help each client
            make an informed decision for their family.
          </p>
        </div>
        <a href={`tel:${site.phone_href}`} className="btn-primary mt-8" data-testid="agent-call-button"
          onClick={() => track("phone_click", { location: "agent_profile" })}>
          <Phone className="h-5 w-5" aria-hidden="true" /> Speak With Michael — {site.phone_display}
        </a>
      </Reveal>
    </div>
  );
}
